<div class="nav-tab-bar-container" [class.is-build-page]="isBuildPage">
  <div class="nav-tab-bar-items">
    <!-- Overview Icon -->
    <div
      class="nav-item relative overview-toggle-btn"
      [class.active]="activeItem === null"
      [class.menu-disabled]="disabled"
      tabindex="0"
      (click)="goToOverview($event)"
      (keydown.enter)="goToOverview($event)"
    >
      <app-four-mini-cubes-icon height="18" width="18"></app-four-mini-cubes-icon>
    </div>

    <!-- Pinned Items (drag-drop enabled) -->
    <ng-container *ngIf="config.enablePinning && pinnedItems.length > 0">
      <div
        cdkDropList
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="dropPinned($event)"
        class="pinned-tabs-container"
      >
        <div
          class="nav-tab-item pinned-tab relative"
          *ngFor="let item of pinnedItems; trackBy: trackById"
          [class.active]="activeItem?.id === item.id"
          [id]="'tab-' + item.id"
          tabindex="0"
          [cdkDragDisabled]="!config.enableDragDrop"
          cdkDrag
          (click)="handleTabClick(item)"
          (keydown.enter)="handleTabClick(item)"
        >
          <app-nav-menu-icon [icon]="item.icon" [size]="18"></app-nav-menu-icon>
          <span *ngIf="activeItem?.id === item.id">{{ item.label | translate }}</span>
        </div>
      </div>
    </ng-container>

    <!-- Divider -->
    <div
      class="nav-divider"
      *ngIf="config.enablePinning && pinnedItems.length > 0 && (unpinnedSelectedItems.length > 0 || isMenuOpen)"
    ></div>

    <!-- Dynamic Tabs -->
    <div
      class="dynamic-tabs-container"
      [class.d-none]="unpinnedSelectedItems.length === 0"
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)"
    >
      <div
        class="nav-tab-item relative"
        *ngFor="let item of unpinnedSelectedItems; trackBy: trackById"
        [class.active]="activeItem?.id === item.id"
        [id]="'tab-' + item.id"
        tabindex="0"
        [cdkDragDisabled]="!config.enableDragDrop"
        cdkDrag
        (click)="handleTabClick(item)"
        (keydown.enter)="handleTabClick(item)"
      >
        <app-nav-menu-icon [icon]="item.icon" [size]="18"></app-nav-menu-icon>
        <span>{{ item.label | translate }}</span>

        <app-rt-icon-close
          class="close-tab-btn"
          [width]="10.8"
          [height]="10.8"
          (click)="closeTab(item, $event)"
        ></app-rt-icon-close>
      </div>
    </div>

    <!-- Plus Menu Button -->
    <div
      class="nav-item relative menu-toggle-btn"
      [class.active-icon]="isMenuOpen"
      [class.menu-disabled]="disabled"
      tabindex="0"
      (click)="toggleMenu($event)"
      (keydown.enter)="toggleMenu($event)"
    >
      <app-plus-icon [size]="18"></app-plus-icon>

      <div
        class="nav-tab-bar-menu"
        [ngClass]="menuPositionClass"
        *ngIf="isMenuOpen"
        tabindex="0"
        (click)="menuClick($event)"
        (keydown.enter)="menuClick($event)"
      >
        <ng-container *ngFor="let group of groupedMenuItems; trackBy: trackByGroup">
          <div
            class="menu-group-header"
            *ngIf="config.enableGrouping && group.group"
          >
            {{ group.group | translate }}
          </div>
          <ng-container *ngFor="let item of group.items; trackBy: trackById">
            <div
              class="menu-item"
              [class.pinned-menu-item]="item.pinned"
              tabindex="0"
              (click)="handleItemClick(item, $event)"
              (keydown.enter)="handleItemClick(item, $event)"
            >
              <app-nav-menu-icon [icon]="item.icon" [size]="18"></app-nav-menu-icon>
              <span>{{ item.label | translate }}</span>

              <ng-container *ngIf="config.enablePinning">
                <app-pinned-icon
                  *ngIf="item.pinned"
                  class="pin-btn is-pinned"
                  (click)="togglePin(item, $event)"
                ></app-pinned-icon>
                <app-pin-icon
                  *ngIf="!item.pinned"
                  class="pin-btn"
                  (click)="togglePin(item, $event)"
                ></app-pin-icon>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>

        <div class="menu-empty" *ngIf="unpinnedMenuItems.length === 0">
          {{ 'NAV_TAB_ALL_OPEN' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
